const state = {
    ready: false,
    totalCount: 0,
    activeParticipantCount: 0,
    participants: []
};

const getters = {
    participantsList: state => {
        return state.participants
            .filter(x => x.participantId)
            .map(x => { return { id: x.participantId, name: x.firstName + ' ' + x.lastName }})
            .sort(function(a,b){ return a.name.localeCompare(b.name); });
    }
};

const actions = {
    async load({ commit, rootState}, data) {
        commit('setReady', false);
        let letter = null;
        let id = rootState.employer.employerId;
        if (data && data.employerId) id = data.employerId;
        if (data && data.letter) letter = data.letter;
        if (!id) return;

        let url = `/participant/employer/${id}/employees`;
        let result = await romeApi.get(url, { order: "asc", letter: letter });
        commit('setData', { participants: result.items, totalCount: result.total, activeParticipantCount: result.activeParticipantCount });
        commit('setReady', true);
    },
};

const mutations = {
    setReady(state, data) {
        state.ready = data;
    },
    setData(state, data) {
        utils.copyCommonProperties(data, state);
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-participants.js